export default "__VITE_ASSET__0c529d07__"